import React from "react";
import { ImageBackground } from "react-native";
import { Field } from "react-final-form";
import { graphql } from "react-apollo";
import styled from "styled-components/native";
import gql from "graphql-tag";
import { layoutCss } from "../layout/common";
import placeholderImage from "../assets/images/placeholder.png";

// We get the border-radius this way because native does not support percentages (50%)
const Wrapper = styled(ImageBackground)`
  ${layoutCss}
`;

/**
 * Display an image based on a field in a form.
 * This field does not allow uploading a new image, if that functionality is needed use FormUploadImageField.
 */
const FormImageField = ({ data: { ConnectionInfo: { imageResizerUrl } = {} }, size, bucketIndex, templateIndex, name, src, placeholder, children, ...restProps }) => (
  <Field name={name}>
    {({ input }) => {
      let source =
        // If a specific image was specified we use that, used to preview an image that is being uploaded for example
        src
        // We use the server image (with resizer)
        || (input.value && `${imageResizerUrl}/image?bucketIndex=${bucketIndex}&templateIndex=${templateIndex}&name=original&pk=${input.value}&width=${size * 2}`)
        // || (input.value && `${imageResizerUrl}/imageresizer/image?bucketIndex=${bucketIndex}&templateIndex=${templateIndex}&name=original&pk=${input.value}&width=${size * 2}`)
        // Theres no image on the server or a recently uploaded image, so we use the placeholder
        || placeholder;

      if (typeof source === "string") {
        // Native requires us to wrap URLs in an object
        source = {uri: source};
      }

      return (
        <Wrapper
          {...restProps}
          resizeMode="cover"
          imageStyle={{
            ...restProps.imageStyle,

            // We do this here to allow the camera icon to go out of the border edge
            borderRadius: size / 2
          }}
          style={{
            ...restProps.style,

            width: size,
            height: size
          }}
          defaultSource={placeholder}
          source={source}
        >
          {children({ input })}
        </Wrapper>
      );
    }}
  </Field>
);

FormImageField.defaultProps = {
  children: () => {},
  bucketIndex: 0,
  templateIndex: 0,
  placeholder: placeholderImage
};

export default graphql(gql`query { ConnectionInfo @client { imageResizerUrl } }`)(FormImageField);
